var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.type,{ref:"icon",tag:"component",staticClass:"icon",class:_vm.type,attrs:{"aria-label":_vm.alt}})
}
var staticRenderFns = []

export { render, staticRenderFns }